<app-form-box>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<app-form-label>Reset Password</app-form-label>

		<br />

		<app-password-field
			[fg]="form"
			formGroupOrControlName="password"
			label="New Password"
			autocomplete="new-password"
		></app-password-field>

		<br />

		<app-password-field
			[fg]="form"
			formGroupOrControlName="confirmPassword"
			label="Confirm Password"
			autocomplete="new-password"
		></app-password-field>

		<br />

		<app-form-submit-button
			[disabled]="!form.valid || loading || !code || !source"
			[loading]="loading"
		>
			Save
		</app-form-submit-button>
	</form>

	<div class="footer-links">
		<app-form-link (click)="onBack()">Back</app-form-link>
	</div>
</app-form-box>
